import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { KeyEventUtil } from 'utils'

const FechaAlmacenamientoFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('date-fechaVencimiento', e)
  }, [])

  return (
    <Form.Group>
      <Form.Label text='FEC. ALMACEN' htmlFor='date-fechaAlmacenamiento' md={6} alignRightAt='md' />
      <Col md={6}>
        <Field name='fechaAlmacenamiento'>
          {({ field }) => (
            <Form.InputDate {...field} id='date-fechaAlmacenamiento' disabled={fIsSubmitting} isInvalid={iTouched && iError} onKeyDown={onKeyDown} />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(FechaAlmacenamientoFormGroup)
